export default "console.log(\"Olá Mundo!\");";